/*Import Estilo*/
import './index.scss';

/*Import Bibliotecas*/
import React, { useEffect, useRef, useState } from 'react';

export default function CookieConsent() {
    const [consentGiven, setConsentGiven] = useState(false);
    const [isModalCookiesOpen, setIsModalCookiesOpen] = useState(false);
    const caixaDeDialogoCookies = useRef(null);

    useEffect(() => {
        caixaDeDialogoCookies.current = document.getElementById("CaixaDeDialogoCookies");
    }, []);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (consent) {
            setConsentGiven(true);
        } else {
            setIsModalCookiesOpen(true); 
        }
    }, []);

    const fecharModalCookies = () => {
        if (caixaDeDialogoCookies.current) {
            caixaDeDialogoCookies.current.close();
            setIsModalCookiesOpen(false); 
        }
    };

    const mostrarModalCookies = () => {
        if (caixaDeDialogoCookies.current) {
            caixaDeDialogoCookies.current.showModal();
            setIsModalCookiesOpen(true); 
        }
    };

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', true);
        setConsentGiven(true);
        fecharModalCookies(); 
    };

    if (consentGiven) {
        return null; 
    }

    return (
        <div className="cookie-consent">
            <dialog id="CaixaDeDialogoCookies" className={isModalCookiesOpen ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <h1>Política de Cookies da Fracaro Store</h1>
                        <p><strong>Última atualização: [08/10/2024]</strong></p>
                        <p>Na Fracaro Store, utilizamos cookies para melhorar sua experiência em nosso site. Esta Política de Cookies explica o que são cookies, como os usamos, como terceiros com os quais podemos colaborar podem usar cookies em nosso site e suas opções em relação aos cookies.</p>
                        <p>1. <strong>O que são cookies?</strong><br />
                            Cookies são pequenos arquivos de texto que são usados para armazenar informações. Eles são armazenados em seu dispositivo quando o site é carregado em seu navegador. Esses cookies ajudam o site a funcionar corretamente, torná-lo mais seguro, proporcionar melhores experiências para o usuário e entender como o site funciona.</p>
                        <p>2. <strong>Como usamos os cookies?</strong><br />
                            Ao acessar nosso site, você pode encontrar cookies de várias categorias, incluindo:<br />
                            - Cookies essenciais: necessários para o funcionamento do site;<br />
                            - Cookies de desempenho: ajudam a entender como os visitantes interagem com o site, coletando informações sobre áreas visitadas e o tempo gasto em cada página;<br />
                            - Cookies de funcionalidade: permitem que o site lembre suas escolhas e forneça recursos melhorados;</p>
                        <p>3. <strong>Cookies de terceiros</strong><br />
                            Também podemos usar cookies de terceiros, como serviços de análise e publicidade, para coletar informações sobre seu uso do site e para veicular anúncios relevantes para você.</p>
                        <p>4. <strong>Suas opções em relação aos cookies</strong><br />
                            Você pode optar por não aceitar cookies ou excluir cookies já existentes através das configurações do seu navegador. No entanto, isso pode afetar a funcionalidade do site e sua experiência de navegação.</p>
                        <p>5. <strong>Alterações nesta Política de Cookies</strong><br />
                            Podemos modificar esta Política de Cookies a qualquer momento. As alterações serão publicadas nesta página e a data da última atualização será atualizada.</p>
                    </div>
                    <button id="bnt-FecharCookies" onClick={fecharModalCookies}>
                        Ok
                    </button>
                </div>
            </dialog>

            <div className='texto-Cookie'>
                <p>Usamos cookies para melhorar sua experiência. Ao continuar, você concorda com nossa <button className='bnt-MostrarCookie' onClick={mostrarModalCookies}>Política de Cookies</button>.</p>
                <button className='bnt-AceitarCookie' onClick={handleAccept}>Aceitar</button>
            </div>
        </div>
    );
}